<script lang="ts">
	import { format } from 'svelte-i18n';
	import type { Device } from 'src/types/Device';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import LiquidLevelIntroductionModal from '../Modals/Onboarding/LiquidLevel/LiquidLevelIntroductionModal.svelte';
	import { Button, ButtonV2, Text } from '@Shelly/shelly-design-system/index';

	export let device: Device;

	let showModal = false;

	$: ButtonComp = $showNewLayout ? ButtonV2 : Button;
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_introduction_wizard', {
		default:
			'Review how the sensor works, where to install it, how to calibrate Empty and Full, and what the button actions do. You can reopen this introduction anytime.',
	})}
</Text>

<svelte:component
	this={ButtonComp}
	size="m"
	width="full"
	aria-label={$format('button_start_introduction_wizard', { default: 'Start introduction' })}
	on:click={() => {
		showModal = true;
	}}
>
	{$format('button_start_introduction_wizard', { default: 'Start introduction' })}
</svelte:component>

<LiquidLevelIntroductionModal {device} bind:showModal />
